import styled from "styled-components";
import { Dropdown, Grid, Label, Link as ExternalLink } from "@trussworks/react-uswds";
import { useTranslation } from "react-i18next";
import { ReactComponent as Globe } from "../images/globe.svg";
import ColoradoBhaLogo from "../images/logos/co_gov_bha_white.png";
import caretDownURL from "../images/caret-down.svg";

const StyledDropdown = styled(Dropdown)`
  border: none;
  background: inherit;
  width: fit-content;
  padding-right: 1rem;
  margin-top: 0;
  font-size: 0.8rem;
  color: white;

  background-image: url(${caretDownURL});
  background-repeat: no-repeat;
  background-position: right;
  background-size: 15%;
`;

const BannerDesktopText = styled.div`
  color: white;
  padding-left: 15px;
  display: inline-flex;
  @media (max-width: 640px) {
    display: none;
  }
`;

const BannerMobileText = styled.div`
  color: white;
  padding-left: 15px;
  font-size: 10px;
    display: none;
  @media (max-width: 640px) {
    display: inline-flex;
  }
`;

function Banner() {
  const { t, i18n } = useTranslation();

  return (
    <Grid row className="Banner usa-dark-background font-body-3xs flex-align-center">
      <Grid col={8}>
        <Grid row>
          <ExternalLink
            href="https://bha.colorado.gov/"
            target="_blank"
            rel="noreferrer"
            className="padding-left-8 padding-right-2 display-none tablet:display-flex"
          >
            <img
              src={ColoradoBhaLogo}
              height={16}
              width={86}
              alt={"https://bha.colorado.gov/"}
            />
          </ExternalLink>
          <BannerDesktopText>{t("officialBhaDesktop")}</BannerDesktopText>
          <BannerMobileText>{t("officialBhaMobile")}</BannerMobileText>
        </Grid>
      </Grid>
      <Grid col className="padding-x-2 flex-align-center flex-justify-end">
        <Grid row className="flex-justify-end flex-align-center">
          <Globe height={15} fill="white" />
          <Label
            htmlFor="change-language"
            className="display-none tablet:display-flex margin-top-0 margin-left-1 font-body-3xs text-white"
          >
            {t("changeLanguage")}
          </Label>
          <StyledDropdown
            name="change-language"
            id="change-language"
            defaultValue={i18n.language}
            onChange={(evt) => i18n.changeLanguage(evt.target.value)}
          >
            <option className="usa-dark-background" value="en">
              English
            </option>
            <option className="usa-dark-background" value="es">
              Español
            </option>
          </StyledDropdown>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Banner;
